<template>
  <div class="w-full flex flex-col items-center space-y-6">
    <!-- Título -->
    <h2>
      <span class="block text-[#73793B] text-center font-serif mb-6 text-[42px]">
        Oferta académica
      </span>
    </h2>

    <!-- Botones -->
    <div class="flex md:space-x-4 space-x-2 max-w-[1200px] w-full">
      <button
        v-for="(btn, i) in botones"
        :key="i"
        @click="selected = i"
        class="md:px-4 px-2 py-2 rounded-none md:text-base text-sm transition duration-300 ease-in-out w-full focus:outline-none "
        :class="[
          selected === i
            ? 'bg-hgreen text-white shadow-md'
            : 'bg-[#F1F2F3] text-black hover:bg-hgreen hover:text-white'
        ]"
      >
        {{ btn }}
      </button>
    </div>

    <!-- Contenido dinámico -->
    <div
      v-if="selected !== null"
      class="max-w-[1200px] w-full"
    >
      <!-- Contenido Botón 1 -->
      <div v-if="selected === 0" class="flex flex-col w-full justify-center items-center">
        <div class="flex flex-col md:flex-row items-center justify-center mb-16 w-full max-w-4xl lg:max-w-[1200px]">
          <!-- Imagen -->
          <div class="order-2 md:order-1 flex w-full md:w-1/2 justify-center md:justify-end lg:px-0 px-8">
            <img
              src="/pagesImages/licenciaturas-estructura.webp"
              width="494"
              height="494"
              loading="lazy"
              class="w-auto h-auto md:mt-0 mt-6"
              alt="Licenciaturas o Pregrados Humanitas"
            />
          </div>
          <!-- Texto -->
          <div class="order-1 md:order-2 flex flex-col lg:px-14 px-8 justify-center md:justify-start  md:py-0 w-full md:w-1/2 ">
            <p class="text-center md:text-left line-height-36 text-4xl text-[#73793B] mb-4 font-serif">
              Licenciaturas o Pregrados
            </p>
            <ul class="text-left pl-6 space-y-1 list-disc">
              <li>Administración</li>
              <li>Contabilidad</li>
              <li>Derecho *</li>
              <li>Educación</li>
              <li>Psicología</li>
            </ul>
            <p class="mt-4 text-sm italic">
              *Programa académico alineado al sistema jurídico y leyes mexicanas.
            </p>
          </div>
        </div>
      </div>

      <!-- Contenido Botón 2 -->
      <div v-else-if="selected === 1" class="flex flex-col w-full justify-center items-center">
        <div class="flex flex-col md:flex-row items-center justify-center mb-16 w-full max-w-4xl lg:max-w-[1200px]">
          <!-- Texto -->
          <div class="order-1 md:order-1 flex flex-col lg:px-14 px-8 md:py-0 w-full md:w-1/2 items-center md:items-start">
            <p class="text-center md:text-left line-height-36 text-4xl text-[#73793B] mb-4 font-serif">
              Maestrías
            </p>
            <ul class="text-left pl-6 space-y-1 list-disc">
              <li>Alta Dirección</li>
              <li>Derecho Corporativo *</li>
              <li>Educación</li>
              <li>Psicoterapia con un enfoque Psicoanalítico</li>
            </ul>
            <p class="mt-4 text-sm italic">
              *Programa académico alineado al sistema jurídico y leyes mexicanas.
            </p>
          </div>
          <!-- Imagen -->
          <div class="order-2 md:order-2 flex w-full md:w-1/2 justify-center md:justify-start lg:px-0 px-8">
            <img
              src="/pagesImages/estructura-academica-educacion.webp"
              width="494"
              height="494"
              loading="lazy"
              class="w-auto h-auto md:mt-0 mt-6"
              alt="Maestrías Humanitas"
            />
          </div>
        </div>
      </div>

      <!-- Contenido Botón 3 -->
      <div v-else-if="selected === 2" class="flex flex-col w-full max-w-[1200px] justify-center items-center">
        <div class="flex flex-col md:flex-row items-center justify-center mb-16 w-full max-w-4xl lg:max-w-[1200px]">
          <!-- Imagen -->
          <div class="order-2 md:order-1 flex w-full md:w-1/2 justify-center md:justify-end lg:px-0 px-8">
            <img
              src="/pagesImages/landing-virtual-doctorado.webp"
              width="494"
              height="494"
              loading="lazy"
              class="w-auto h-auto md:mt-0 mt-6"
              alt="Explora los diplomados"
            />
          </div>
          <!-- Texto -->
          <div class="order-1 md:order-2 flex flex-col lg:px-14 px-8 md:py-0 w-full md:w-1/2">
            <p class="text-center md:text-left line-height-36 text-4xl text-[#73793B] mb-4 font-serif">
              Diplomados
            </p>
            <ul class="text-left pl-6 space-y-1 list-disc">
                <li>Reflexiones psicoanalíticas sobre el cuerpo, la anorexia y la obesidad</li>
                <li>Perfiles criminales</li>
                <li>Terapia cognitiva conductual</li>
                <li>Tanatología</li>
                <li>Psicología del Desarrollo Infantil: Enfoques clásicos y contemporáneos</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "BotonesConContenido",
  setup() {
    const botones = ["Licenciaturas o Pregrados", "Maestrías", "Diplomados"];
    const selected = ref<number | null>(0); // inicializo en 0 para que cargue Licenciaturas por defecto

    return { botones, selected };
  },
});
</script>
